import * as AppPics from 'assets/images';
import ESDropDown from 'components/molecules/ESDropDown';
import ESClassDropDown from 'components/molecules/ESClassDropDown';
import ESTDropDownType1 from 'components/molecules/ESTDropDownType1';
import { useState, useContext } from 'react';
import { UserContext } from 'context/UserContext';
import RecentCourses from './RecentCourses';
import AllCourses from './AllCourses';
import DraftCourses from './DraftCourses';
import DeactivatedCourses from './DeactivatedCourses';
import ArchivedCourses from './ArchivedCourses';
import { Link } from 'react-router-dom';
import useCourses from 'hooks/API/GET/useCourses';
import useManageCourse from 'hooks/API/useManageCourse';
import BasicDelete from 'components/molecules/Modal/Delete/BasicDelete';

function Courses() {
  const [activeTab, setActiveTab] = useState('recent');
  const [displayType, setDisplayType] = useState('grid');
  const [enableFilter, setEnableFilter] = useState(false);
  const [actions, setActions] = useState(Object.assign({}, actionsConfig));
  const [courseFilter, setCourseFilter] = useState({});
  const { userPermissions = {} } = useContext(UserContext);

  const [keyword, setKeyword] = useState();
  const [searchTerm, setSearchTerm] = useState('');

  const { data, isLoading, isError } = useCourses({
    enabled: true,
    configs: {
      params: {
        type: activeTab,
        keyword,
        ...courseFilter,
      },
    },
  });

  const { isLoading: fetching, mutate } = useManageCourse();
  function handleInfoChange(data = {}) {
    setCourseFilter((x) => ({ ...x, ...data }));
  }
  function handleSave(data = {}) {
    if (fetching) return;

    mutate({ type: 'UPDATE', ...data });
  }

  return (
    <>
      <BasicDelete
        open={actions.open}
        closeModal={() => setActions(Object.assign({}, actionsConfig))}
        Header={actions.Header}
        Body={actions.Body}
        handleConfirmation={() => {
          if (actions.isDeleteOperation) handleSave({ type: 'DELETE', ...actions.data });
          else handleSave(actions.data);
          setActions(Object.assign({}, actionsConfig));
        }}
      />
      <div className="mainWraper coursetabsection">
        <div className="tab">
          <ul className="tab__menu">
            <li
              onClick={() => {
                setActiveTab('recent');
                setKeyword('');
                setSearchTerm('');
              }}
              className={`${activeTab === 'recent' ? 'active' : ''}`}
            >
              Recent Courses
            </li>
            <li
              onClick={() => {
                setActiveTab('all');
                setKeyword('');
                setSearchTerm('');
              }}
              className={`${activeTab === 'all' ? 'active' : ''}`}
            >
              All Courses
            </li>
            <li
              onClick={() => {
                setActiveTab('draft');
                setKeyword('');
                setSearchTerm('');
              }}
              className={`${activeTab === 'draft' ? 'active' : ''}`}
            >
              Draft Courses
            </li>
            <li
              onClick={() => {
                setActiveTab('deactivate');
                setKeyword('');
                setSearchTerm('');
              }}
              className={`${activeTab === 'deactivate' ? 'active' : ''}`}
            >
              Deactivated
            </li>
            <li
              onClick={() => {
                setActiveTab('archive');
                setKeyword('');
                setSearchTerm('');
              }}
              className={`${activeTab === 'archive' ? 'active' : ''}`}
            >
              Archived
            </li>
          </ul>
          <div className="tab__content">
            <div className="tab__contentMenu">
              <ul className="tab__contentMenu-list">
                <li>
                  <button type="button" onClick={() => setDisplayType('grid')}>
                    <img src={AppPics.TabGridSvg} alt="Grid view" />
                    <span className="viewsettingtitle">Grid</span>
                  </button>
                </li>
                <li>
                  <button type="button" onClick={() => setDisplayType('table')}>
                    <img src={AppPics.TabListSvg} alt="List view" />
                    <span className="viewsettingtitle">List</span>
                  </button>
                </li>
                <li>
                  <button type="button" onClick={() => setEnableFilter(!enableFilter)}>
                    <img src={AppPics.TabFilterSvg} alt="List filter" />
                    <span className="viewsettingtitle">Filter</span>
                  </button>
                </li>
              </ul>

              <div className="mainHeader__search">
                <input
                  className="mainHeader__searchInput"
                  placeholder="Search course..."
                  type="text"
                  value={searchTerm}
                  onChange={(event) => {
                    const __term = event.target.value;
                    setSearchTerm(__term);
                    if (__term === '') setKeyword('');
                  }}
                />
                <span
                  className="mainHeader__searchBtn"
                  onClick={() => {
                    if (searchTerm) {
                      setKeyword(searchTerm);
                    }
                  }}
                >
                  <img src={AppPics.TopMenuSearchSvg} alt="" />
                </span>
              </div>
              <div>
                {userPermissions?.course?.canCreateNew && (
                  <Link to="/courses/add">
                    <button className="btn-left-content add">New Course</button>
                  </Link>
                )}
              </div>
            </div>
            {enableFilter && (
              <div className="row">
                <div className="col-lg-3">
                  <ESTDropDownType1
                    enableAPI
                    value={courseFilter.est}
                    handleChange={(event) => {
                      const est = event.target.value;
                      handleInfoChange({ est, es: '' });
                    }}
                  />
                </div>
                <div className="col-lg-3">
                  <ESDropDown
                    enableAPI={!!courseFilter.est}
                    dependencies={{
                      query: courseFilter.est ? `est=${courseFilter.est}` : ``,
                    }}
                    value={courseFilter.es}
                    handleChange={(event) => {
                      const es = event.target.value;
                      handleInfoChange({ es });
                    }}
                    defaultLook={false}
                  />
                </div>
                <div className="col-lg-3">
                  <ESClassDropDown
                    enableAPI={!!courseFilter.es}
                    dependencies={{
                      query: `esId=${courseFilter.es}`,
                    }}
                    value={courseFilter.classId}
                    handleChange={(event) => {
                      const classId = event.target.value;
                      handleInfoChange({ classId });
                    }}
                    defaultLook={false}
                  />
                </div>

                <div className="col-lg-3 d-flex">
                  <button
                    type="button"
                    className="btn btn-plane p--tint"
                    style={{ alignSelf: 'end' }}
                    onClick={() => {
                      setCourseFilter({});
                      setEnableFilter(false);
                    }}
                  >
                    Clear filter
                  </button>
                </div>
              </div>
            )}

            <div className="tab__contentBody">
              {isLoading ? (
                'Loading...'
              ) : isError ? (
                'Failed to load'
              ) : (
                <>
                  {activeTab === 'recent' && (
                    <RecentCourses
                      data={data?.data || {}}
                      setActions={setActions}
                      modeOfView={displayType}
                    />
                  )}
                  {activeTab === 'all' && (
                    <AllCourses
                      data={data?.data || {}}
                      setActions={setActions}
                      modeOfView={displayType}
                    />
                  )}
                  {activeTab === 'draft' && (
                    <DraftCourses
                      data={data?.data || {}}
                      setActions={setActions}
                      modeOfView={displayType}
                    />
                  )}
                  {activeTab === 'deactivate' && (
                    <DeactivatedCourses
                      data={data?.data || {}}
                      setActions={setActions}
                      modeOfView={displayType}
                    />
                  )}
                  {activeTab === 'archive' && (
                    <ArchivedCourses
                      data={data?.data || {}}
                      setActions={setActions}
                      modeOfView={displayType}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const actionsConfig = { open: false, data: {}, Header: null, Body: null, isDeleteOperation: false };

export default Courses;
